import { call, delay, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { sendTrackingRefreshFailed, sendTrackingRefreshSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL, DEFAULT_URL, LOADING_DELAY } from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';

export default function* sendTrackingRefresh(action) {
  try {
    const { filter, bounds, channel_id } = action.payload;
    const pool = { bounds, channel_id };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      const f = addFilterQueryWithCondition(filter, {});
      if (Object.keys(f)?.length) {
        pool.filter = f;
      }
    }
    yield delay(1500);
    const url = `${BACKEND_URL}/tracking/refresh`;
    const response = yield makeRequest(url, pool, action, 'POST', true);
    if (response.status === OK) {
      const data = yield getBodyJson(response);
      yield put(sendTrackingRefreshSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      const data = yield getBodyJson(response);
      yield put(sendTrackingRefreshFailed());
      yield call(rejectActionPromise(action, { ...data, code: response.status }));
    }
  } catch (e) {
    yield put(sendTrackingRefreshFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
